import {
  faArrowsRotate,
  faWindowFlip,
} from '@fortawesome/pro-regular-svg-icons';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { useMemo } from 'react';

export function ExtractionCardResultsHeaderActions({
  onOpenChatModal,
  onReExtractValues,
  loading,
}: {
  /** Callback when chat button is clicked */
  onOpenChatModal: () => void;
  /** Callback when re-extract values button is clicked */
  onReExtractValues: () => void;
  /** Whether extraction is currently loading */
  loading?: boolean;
}) {
  const iconProps: Omit<FontAwesomeIconProps, 'ref' | 'icon'> = useMemo(
    () => ({
      size: 'sm',
      style: {
        fontSize: '1rem',
        color: 'var(--mantine-text-link)',
      },
    }),
    []
  );

  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title="Re-extract value(s)" placement="top">
        <IconButton
          aria-label="Re-extract value(s)"
          onClick={onReExtractValues}
        >
          <FontAwesomeIcon
            icon={faArrowsRotate}
            {...iconProps}
            spin={loading}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title="Open chat" placement="top">
        <IconButton aria-label="Open chat" onClick={onOpenChatModal}>
          <FontAwesomeIcon icon={faWindowFlip} {...iconProps} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
